<template>
  <span class="error--text">* {{label("message")}}</span>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "RequiredItemText",
  }
</script>

<style scoped lang="sass">
.section-title
  border-left: solid #2f3e6d 8px
  padding-left: 8px
</style>